import Main from '@/components/main';
import SystemManagement from './modules/system-management';
import ProductManagement from './modules/product-management';
import SeedFarmManagement from './modules/seedFarm-management';
import DistributionStation from './modules/distributionStation-management';
import WarehouseManagement from './modules/warehouse-management';
import SaleManagement from './modules/sale-management';
import PreSaleManagement from './modules/preSale-management';
import FinanceManagement from './modules/finance-management';
import MasterManagement from './modules/master-management';
// import CustomerManagerManagement from './modules/customer-manager-management';
import InnerManagement from './modules/inner-management';
import StatAnalyze from './modules/stat-analyze';

/**
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 * }
 */

export default [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true
        },
        component: () => import('@/view/login/login.vue')
    },
    {
        path: '/user',
        name: 'user',
        component: Main,
        meta: {
            title: '用户中心',
            hideInMenu: true
        },
        children: [
            {
                path: '/user-center',
                name: 'user-center',
                meta: {
                    hideInMenu: true,
                    title: '用户中心',
                    notCache: true
                },
                component: () => import('@/view/system-management/user-management/user-center')
            }
        ]
    },
    {
        path: '/',
        name: '_home',
        redirect: '/home',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    hideInMenu: true,
                    title: '首页',
                    notCache: true
                },
                component: () => import('@/view/single-page/home')
            }
        ]
    },
    ProductManagement,
    SeedFarmManagement,
    // DistributionStation,
    WarehouseManagement,
    SaleManagement,
    InnerManagement,
    MasterManagement,
    FinanceManagement,
    // CustomerManagerManagement,
    StatAnalyze,
    // PreSaleManagement,
    SystemManagement,

    {
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/404.vue')
    }
];
